var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-signin",attrs:{"id":"linkedin"},on:{"click":_vm.onClick}},[_c('img',{staticClass:"social-logo",attrs:{"src":"/static/images/signin/linkedin/linkedin.svg"}}),_vm._v(" "),_c('div',{staticClass:"social-text",attrs:{"id":"linkedin"}},[_vm._t("default",[_vm._v("Sign in with LinkedIn")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e38140e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/LinkedInSignIn.vue
// module id = Rjv0
// module chunks = 1